import type { IEntityModel } from './base'
import type { IDexcomAccount } from './dexcom_account'
import type { IDexcomIntegration } from './dexcom_integration'

export enum DexcomAppRegion {
  US = 'us',
  EU = 'eu',
  Sandbox = 'sandbox',
}

export interface IDexcomApp extends IEntityModel {
  dexcomIntegrationId: string
  dexcomIntegration?: IDexcomIntegration
  name: string
  description: string
  region: DexcomAppRegion
  clientId: string
  secretClientSecret: string
  totalAccounts: number
  dexcomAccountList?: IDexcomAccount[]
}
